import { Exception } from 'util/domain/exception';

export enum LinkCreationErrorCode {
    PASSWORD_POLICY = 'PASSWORD_POLICY',
    DEFAULT = 'DEFAULT'
}

const DEFAULT_CREATION_ERROR = 'Failed to create link';

export class LinkCreationException extends Exception<LinkCreationErrorCode> {
    constructor(
        public gettextCatalog:ng.gettext.gettextCatalog,
        errorCode:LinkCreationErrorCode,
        message:string = gettextCatalog.getString(DEFAULT_CREATION_ERROR)
    ) {
        super(errorCode, LinkCreationErrorCode[errorCode], message)
        this.userMessage = message;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/link-creation-exception.ts